const ITEMS = [
  "Premium Branding",
  "2D / 3D Animation",
  "Motion Graphics",
  "Website Design",
  "3D CGI Ads",
  "Performance Marketing",
  "Content Writing",
  "Commercial Ad Shoots",
  "AI Creative",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-[hsl(var(--border))] bg-[hsl(var(--bg-soft))] py-8 overflow-hidden"
    >
      <div className="flex w-max marquee-track">
        {row.map((item, i) => (
          <div key={`${item}-${i < ITEMS.length ? "a" : "b"}`} className="flex items-center gap-8 pr-8">
            <span className="font-head text-3xl font-semibold md:text-5xl">
              {i % 2 === 0 ? (
                item
              ) : (
                <span className="outline-text">{item}</span>
              )}
            </span>
            <span className="text-2xl text-[hsl(var(--primary))] md:text-4xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
